module.exports = __webpack_public_path__ + "static/img/banner3.316b65c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/banner3.jpg
// module id = J3xp
// module chunks = 1